window.addEventListener('DOMContentLoaded', () => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealOnScroll() {
        const items = document.querySelectorAll('.timeline-v-item-scroll');
        items.forEach((item) => {
            const rect = item.getBoundingClientRect();
            const triggerPoint = window.innerHeight - (window.innerHeight / 3.5);
            if (rect.top < triggerPoint) {
                item.classList.add('revealed');
            }
        });
    }

    if (!reducedMotion) {
        window.addEventListener('scroll', revealOnScroll);
        revealOnScroll();
    }

    /* Video component 2*/

    const supportsVideo = !!document.createElement("video").canPlayType;
    if(supportsVideo){
        const video_containers = document.querySelectorAll(".video-media-container");
        video_containers.forEach((video_container) => {

            const play_btn = video_container.querySelector(".video-play-button");
            const video = video_container.querySelector("video");

            video.controls = false;

            // remove thumb when video starts playing
            video.addEventListener("play", (e)=>{
                const target = e.target.parentNode;
                // Hide thumbnail
                target.classList.add("playing");
            });


            if(play_btn){
                // Play Button
                play_btn.addEventListener("click", (e)=>{
                    e.preventDefault();
                    video.play();
                });
            }

            video.addEventListener("click", (e) => {
                e.preventDefault();
                if (video.paused || video.ended) {
                    video.play();
                } else {
                    video.pause();
                }
            });
        });
    }
});




